// src/components/Issues/utils.js
export const getStatusColor = (status) => {
  const map = {
    'Pending': 'warning',
    'Unsolved': 'info',
    'Solved': 'success',
    'Closed': 'default',
    'Unsolvable': 'error',
  };
  return map[status] || 'default';
};

export const formatFileName = (file, index) => {
  return file?.title || file?.file_name || file?.name || `File ${index + 1}`;
};

export const formatFileType = (file, filePath) => {
  return (file?.type || file?.mime_type || filePath?.split('.').pop())?.toUpperCase();
};